import { Navigate, Outlet } from 'react-router-dom';
import { useWorkspace } from '../workspace/WorkspaceProvider';
import { isWorkspaceAdmin } from '../api/types';

/**
 * Route guard for admin-only tabs (Settings → Workspace; People → Access since
 * steward-app#1921 and People → Advisors since steward-app#1922). Non-admins who deep-link one are bounced to the default Settings tab,
 * wherever the tab lives. This mirrors the tab visibility in Settings.tsx and PeopleLayout.tsx,
 * and appcore independently enforces admin on the underlying writes — so this is UX gating,
 * not the security boundary.
 *
 * While membership is still resolving (direct load/refresh), render nothing rather
 * than briefly redirecting an admin away.
 */
export function RequireAdmin() {
  const { activeMembership } = useWorkspace();
  if (!activeMembership) return null;
  if (!isWorkspaceAdmin(activeMembership.roleIds)) return <Navigate to="/settings" replace />;
  return <Outlet />;
}
